import React from "react";
import { MapContainer, TileLayer, useMapEvent } from "react-leaflet";
import 'leaflet/dist/leaflet.css'
import L from 'leaflet';
const apiKey = process.env.REACT_APP_LEAFT_LET_API_KEY;
const Map = ({ children, center, zoom, scrollWheelZoom, zoomControl = false, style, onClick, temaMapa = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_272a_1_35c523a1879227e1480394f9' }) => {
    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });
    console.log("temaMapa",temaMapa);
    
    return (
        <MapContainer
            center={center}
            zoom={zoom}
            scrollWheelZoom={scrollWheelZoom}
            zoomControl={zoomControl}
            style={style}
        >
           
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; CARTO'
                url={temaMapa}
                errorTileUrl="https://upload.wikimedia.org/wikipedia/commons/e/e0/Blank.png"
            />
            <TileLayer
                attribution='&copy; OpenStreetMap &copy; CARTO'
                url={temaMapa}
                errorTileUrl="https://upload.wikimedia.org/wikipedia/commons/e/e0/Blank.png"
            />
            <TileLayer
                attribution='Traffic data © <a href="https://www.tomtom.com/">TomTom</a>'
                url={`https://api.tomtom.com/traffic/map/4/tile/flow/relative0/{z}/{x}/{y}.png?key=${apiKey}`}
                opacity={0.8}
            />
            {children}
        </MapContainer>
    )
}
export default Map